// extracted by mini-css-extract-plugin
export default {"p":"b440c9f0f5 _52ae441122 _8d7af39215","clr":"_1815626405","dls":"d64194a099"};